import React from 'react';
import { infoPageStyles as styles } from './sharedStyles';
import { COLORS } from '../../constants';

const SocialMedia = () => {
  const InstagramIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="20" height="20" rx="5" stroke="#CE1126" strokeWidth="2"/>
      <circle cx="12" cy="12" r="4" stroke="#CE1126" strokeWidth="2"/>
      <circle cx="18" cy="6" r="1.5" fill="#CE1126"/>
    </svg>
  );

  const socialLinks = [
    {
      platform: 'Instagram',
      handle: '@redbirdmarkets.isu',
      url: 'https://instagram.com/redbirdmarkets.isu',
      description: 'Follow for featured listings, student spotlights, marketplace updates, and campus events',
      icon: <InstagramIcon />
    }
  ];

  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>Connect With Us</h1>
        <p style={styles.headerSubtitle}>Follow @redbirdmarkets.isu on Instagram</p>
      </div>

      <div style={styles.contentContainer}>
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Follow Us on Instagram</h2>
          <p style={styles.text}>
            Stay connected with Redbird Markets on Instagram! Get updates on new features, 
            featured listings, campus events, and connect with fellow ISU students.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px',
          marginBottom: '40px'
        }}>
          {socialLinks.map((social) => (
            <a
              key={social.platform}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: 'white',
                padding: '24px',
                borderRadius: '12px',
                border: `2px solid ${COLORS.lightGray}`,
                textDecoration: 'none',
                color: 'inherit',
                transition: 'all 0.2s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.borderColor = COLORS.primary;
                e.currentTarget.style.boxShadow = `0 6px 20px ${COLORS.primary}20`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = COLORS.lightGray;
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{marginBottom: '12px'}}>{social.icon}</div>
              <h3 style={{...styles.subsectionTitle, marginTop: 0}}>{social.platform}</h3>
              <p style={{...styles.text, color: COLORS.primary, fontWeight: 600, marginBottom: '8px'}}>
                {social.handle}
              </p>
              <p style={{...styles.text, fontSize: '14px', margin: 0}}>
                {social.description}
              </p>
            </a>
          ))}
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Community Guidelines</h2>
          <p style={styles.text}>
            When engaging with us on Instagram, please remember:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Be respectful and kind to other community members</li>
            <li style={styles.listItem}>No spam, scams, or inappropriate content</li>
            <li style={styles.listItem}>Follow Instagram's terms of service</li>
            <li style={styles.listItem}>Report any concerning behavior to us via DM</li>
            <li style={styles.listItem}>Keep discussions relevant to the marketplace and ISU community</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Contact Through Instagram</h2>
          <p style={styles.text}>
            We monitor Instagram messages and comments regularly. For customer support inquiries:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>DM us @redbirdmarkets.isu for quick questions</li>
            <li style={styles.listItem}>Comment on our posts for public discussions</li>
            <li style={styles.listItem}>For urgent issues, email us at <a href="mailto:redbirdmarket.isu@gmail.com" style={styles.link}>redbirdmarket.isu@gmail.com</a></li>
            <li style={styles.listItem}>Response time: Within 24 hours on weekdays</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Stay Updated</h2>
          <p style={styles.text}>
            Don't miss out on important updates, exclusive deals, and community events. 
            Follow @redbirdmarkets.isu on Instagram to stay in the loop with everything happening at Redbird Markets!
          </p>
        </div>
      </div>
    </div>
  );
};

export default SocialMedia;
